import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getAlbaranesEntradaMercancia`, method: 'GET', body: null, token: token})
}